import AppRoutes from './AppRoutes'
import { roleAllPermission, userAllPermission, packageAllPermission } from '../constant/permissions';

const routes = [
    {
        path: '',
        name: 'blank-page',
        component: () => import ('@/view/apps/dashboard/Dashboard.vue')
    },
    {
        path: '/admin/roles',
        name: 'roles',
        component: () => import ('@/view/apps/roles/Roles.vue'),
        meta: {
            permission: roleAllPermission,
            title: 'Roles'
        }
    },
    {
        name: 'users',
        path: '/admin/users',
        component: () => import ('@/view/apps/users/Users.vue'),
        meta: {
            permission: userAllPermission,
            title: 'Users'
        }
    },
    {
        name: 'packages',
        path: '/admin/packages',
        component: () => import('@/view/apps/packages/Packages.vue'),
        meta: {
            permission: packageAllPermission,
            title: 'Packages'
        }
    },
    ...AppRoutes
];

export default routes;